import { createStyles, Theme } from '@material-ui/core';
import isInteger from 'lodash/isInteger';
import toNumber from 'lodash/toNumber';

import { darkTheme } from '#web-components/styles/themes/darkTheme';

import type { SignatureWidgetProps } from './SignatureWidget';

const styles = ({ spacing }: Theme) => createStyles({
  button: {
    marginRight: spacing(3),
  },
  frameContainer: (props: SignatureWidgetProps) => ({
    height: isInteger(toNumber(props.signWidgetHeight)) && !!toNumber(props.signWidgetHeight)
      ? toNumber(props.signWidgetHeight)
      : spacing(90),
    background: darkTheme.colors.uIBase,
  }),
  hide: {
    display: 'none',
  },
  buttonContainer: {
    marginTop: spacing(7),
    marginBottom: spacing(7),
    display: 'flex',
  },
  title: {
    margin: `${spacing(5)}px 0`,
  },
});

export default styles;
